import React from "react";

import images from "../../../utils/images";

import "./styles.scss";

const SearchBar = (props) => {
  let classes = "";

  if (props.className) {
    classes = props.className;
  }

  return (
    <div className={"SearchBar d-flex align-items-center justify-content-between " + classes}>
      <input
        className="SearchBar__input"
        data-private
        onChange={props.onchange}
        placeholder="Search"
        type="text"
        value={props.value || ""}
      />
      <div className="SearchBar__btn" role="button">
        <img alt="search icon" className="pl-2 mb-1" src={images("./common/search.svg")} />
      </div>
    </div>
  );
};

export default SearchBar;
